module.exports = __webpack_public_path__ + "img/column-icon.0af6f646.svg";